module.exports = __webpack_public_path__ + "media/social-media/insta-icons-e232a7b4.svg";